// extracted by mini-css-extract-plugin
export default {"notice":"RevisionPolicyNotice_notice__Kr7bu","title":"RevisionPolicyNotice_title__LzXHC"};